const SvgDragHandle = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
    <path d="M26.667 12H5.334v2.667h21.333zM5.333 20h21.333v-2.667H5.333z" />
  </svg>;
export default SvgDragHandle;